module.exports = __webpack_public_path__ + "img/ic_liveticker_other.4c79a199.svg";